import {
  AGENCY_GETALL_SUCCESS,
  AGENCY_GETALL_FAIL,
  AGENCY_UPSERT_SUCCESS,
  AGENCY_UPSERT_FAIL,
  AGENCY_DELETE_SUCCESS,
  AGENCY_DELETE_FAIL,
  SET_MESSAGE
} from "./types";

import AgencyService from "../services/agency.service";

export const getAgencies = () => (dispatch) => {
  return AgencyService.getAgencies().then(
    (data) => {
      dispatch({
        type: AGENCY_GETALL_SUCCESS,
        payload: { agencies: data },
      });
      return Promise.resolve();
    },
    (error) => {
      dispatch({ type: AGENCY_GETALL_FAIL });
      dispatch({
        type: SET_MESSAGE,
        payload: `Agencies retrieval failed : ${error}`,
      });
      return Promise.reject();
    }
  );
};

export const upsertAgency = (agency) => (dispatch) => {
  return AgencyService.upsertAgency(agency).then(
    (data) => {
      dispatch({ type: AGENCY_UPSERT_SUCCESS, payload: data });
      return Promise.resolve();
    },
    (error) => {
      dispatch({ type: AGENCY_UPSERT_FAIL });
      dispatch({
        type: SET_MESSAGE,
        payload: `Agency upsert failed - ${error}`,
      });
      return Promise.reject();
    }
  );
};

export const deleteAgency = (agency_id) => (dispatch) => {
  return AgencyService.deleteAgency(agency_id).then(
    () => {
      dispatch({ type: AGENCY_DELETE_SUCCESS, payload : agency_id });
      return Promise.resolve();
    },
    (error) => {
      dispatch({ type: AGENCY_DELETE_FAIL });
      dispatch({ type: SET_MESSAGE, payload: `Agency upsert failed - ${error}` });
      return Promise.reject();
    }
  );
};